import React from 'react';
import { Switch, Route } from "react-router-dom";

import CartPlaylist from './CartPlaylist';

function CartRoute() {
  return (
    <Switch>
      <Route exact path={['/cart', '/cart/:refresh']} render={ props => <CartPlaylist refresh={props.match.params.refresh} /> } />
    </Switch>
  );
}

export default CartRoute;
